<template>
  <el-dialog
      title="设置"
      :visible.sync="visible"
      width="30%"
      @close="handleClose"
  >
    <div class="settings-content">
      <el-form :model="form" label-width="120px">
        <el-form-item label="邮件消息提醒">
          <el-switch
              v-model="form.email_notification">
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSave">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import {userApi} from '@/api/user_api'

export default {
  name: 'SettingsDialog',

  props: {
    visible: {
      default: false
    }
  },

  data() {
    return {
      form: {
        user_id: null,
        email_notification: false
      }
    }
  },

  watch: {
    visible: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.initSettings()
        }
      }
    }
  },

  methods: {
    async initSettings() {
      const res = await userApi.getChatSetting()
      if (res.data) {
        this.form = res.data
      }
    },

    handleClose() {
      this.$emit('update:visible', false)
    },

    async handleSave() {
      try {
        await userApi.updateUserSettings(this.form)
        this.$message.success('设置保存成功')
        this.handleClose()
      } catch (error) {
        this.$message.error('设置保存失败：' + (error.message || '未知错误'))
      }
    }
  }
}
</script>

<style scoped>
.settings-content {
  min-height: 100px;
  padding: 20px 0;
}
</style>